define([
    "./monitorableFollowupDashboardOverviewModule",
    "./monitorableFollowupDashboardOverviewController"
], function () {
});
